import { BrowserRouter, Route, Routes } from "react-router-dom";

import "./App.css";

import CategoryPage from "./pages/categories/categoriespage.component";
import CouponsPage from "./pages/coupons/couponsPage.component";
import Home from "./pages/home/home.component";
import Landing from "./pages/landing/landing.component";
import OrderDetailsComponent from "./pages/orderDetails/orderDetails.component";
import OrdersPage from "./pages/orders/ordersPage.component";
import OrganizationPage from "./pages/organization/organizationpage.component";
import PaymentsPage from "./pages/payments/paymentsPage.component";
import ProductPage from "./pages/products/productspage.component";
import RatesPage from "./pages/rates/rates.component";
import ReviewsPage from "./pages/reviews/reviewsPage.component";
import SchemesComponent from "./pages/schemes_new/schemes.jsx";
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Landing />} />
          <Route path="/home" element={<Home />} />
          <Route path="/organizations" element={<OrganizationPage />} />
          <Route path="/categories" element={<CategoryPage />} />
          <Route path="/products" element={<ProductPage />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/payments" element={<PaymentsPage />} />
          <Route path="/coupons" element={<CouponsPage />} />
          <Route path="/order-detail/:id" element={<OrderDetailsComponent />} />
          <Route path="/rates" element={<RatesPage />} />
          <Route path="/schemes" element={<SchemesComponent/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
